import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">Privacy Policy</h1>
          
          <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
            <p className="text-sm text-gray-600 mb-8">
              <strong>Last Updated:</strong> {new Date().toLocaleDateString()}
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Information We Collect</h2>
              <p>
                Colorado First Plumbing & Sewer LLC ("we," "our," or "us") collects information you provide directly to us, 
                such as when you request services, contact us, or use our admin dashboard.
              </p>
              
              <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Information You Provide</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Contact information (name, email, phone number, address)</li>
                <li>Service requests and project details</li>
                <li>Payment information (processed securely through third parties)</li>
                <li>Communication records and service history</li>
              </ul>

              <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Information Collected Automatically</h3>
              <ul className="list-disc pl-6 space-y-2">
                <li>Website usage data and analytics</li>
                <li>Device information and IP addresses</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>

              <h3 className="text-xl font-medium text-gray-900 mt-6 mb-3">Admin Dashboard Data</h3>
              <p>
                Our admin dashboard may access Gmail, calendar, and business management systems to provide 
                efficient customer service. This access is limited to authorized personnel only.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Your Information</h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Provide and improve our plumbing services</li>
                <li>Communicate about your service requests</li>
                <li>Process payments and manage billing</li>
                <li>Send service updates and appointment reminders</li>
                <li>Comply with legal obligations</li>
                <li>Analyze website usage to improve user experience</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Information Sharing</h2>
              <p>We do not sell, trade, or rent your personal information. We may share information:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>With service providers who assist our operations (HouseCall Pro, payment processors)</li>
                <li>When required by law or legal process</li>
                <li>To protect our rights and safety or that of others</li>
                <li>With your explicit consent</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Third-Party Services</h2>
              <p>We use the following third-party services:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li><strong>Google Services:</strong> Gmail API, Google Analytics, Google Maps</li>
                <li><strong>HouseCall Pro:</strong> Business management and scheduling</li>
                <li><strong>BirdEye:</strong> Review management and customer feedback</li>
                <li><strong>Vercel:</strong> Website hosting and analytics</li>
              </ul>
              <p className="mt-3">
                Each service has its own privacy policy governing their data collection and use.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Data Security</h2>
              <p>
                We implement appropriate security measures to protect your information against unauthorized access, 
                alteration, disclosure, or destruction. However, no internet transmission is 100% secure.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Data Retention</h2>
              <p>
                We retain your information as long as necessary to provide services, comply with legal obligations, 
                and resolve disputes. Customer service records are typically retained for 7 years.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc pl-6 space-y-2 mt-3">
                <li>Access and review your personal information</li>
                <li>Request corrections to inaccurate information</li>
                <li>Request deletion of your information (subject to legal requirements)</li>
                <li>Opt out of marketing communications</li>
                <li>Withdraw consent for data processing where applicable</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Cookies and Tracking</h2>
              <p>
                We use cookies and similar technologies to improve website functionality, analyze usage, 
                and provide personalized experiences. You can control cookie settings through your browser.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Children's Privacy</h2>
              <p>
                Our services are not directed to children under 13. We do not knowingly collect personal 
                information from children under 13.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Changes to Privacy Policy</h2>
              <p>
                We may update this privacy policy periodically. We will notify you of material changes 
                by posting the updated policy on our website with a new effective date.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Contact Information</h2>
              <div className="bg-blue-50 p-6 rounded-lg">
                <p><strong>Colorado First Plumbing & Sewer LLC</strong></p>
                <p>Email: <a href="mailto:codee@colorado-plumbing.com" className="text-blue-600 hover:underline">codee@colorado-plumbing.com</a></p>
                <p>Phone: </p>
                <p>Website: <a href="https://colorado-plumbing.com" className="text-blue-600 hover:underline">colorado-plumbing.com</a></p>
              </div>
              <p className="mt-4">
                For privacy-related questions or to exercise your rights, please contact us using the information above.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;